<template>
  <div class="cs-home">
    <!-- Apple 与教育 -->
    <div class="cs-home-part1">
      <div class="container">
        <div class="tit">Apple 与教育。</div>
        <div class="cs-home-con">
          <p class="subtitle">“教育是深深根植于 Apple 的 DNA。” </p>
          <p class="con">Apple 致力于打造高科技与创造力的教育生态系统，通过功能强大的硬件产品与精彩纷呈的 APP 软件以及丰富多样的学习资源，将科技创新带进课堂，为学校、老师、家长和学生，提供高效全面的教学服务。</p>
          <p class="con">创森智云是一家专门提供教育解决方案的 Apple 优质教育合作商，为学校、机构和个人采购和部署 Apple 产品提供支持，帮助教职员工打造一个出色的教学环境，激励学生们随时随地探索、学习，为教育创造无限可能。

创森智云同时提供更深入的 Mac 部署服务。我们在部署阶段提供一站式支持，根据不同类型学校的需求提供高效、安全的定制化解决方案。与此同时，创森智云还提供持续的运维与培训服务，协助教育机构简化管理，提升教学体验，让创新真正走入课堂。</p>
        </div>
      </div>
    </div>
    <!-- 基础教育，，高等教育 -->
    <div class="cs-home-part2">
      <div class="container">
        <el-row :gutter="60">
          <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
            <el-card :body-style="{ padding: '0px' ,textAlign: 'center'}">
              <img src="../assets/img/cs-home-2.jpg" class="image">
              <div class="img-tit">
                <span class="tit">基础教育</span>
                <div class="bottom clearfix">
                  <router-link to="BasicEduTeacherLeader">
                    <el-button type="text" class="button">进一步了解 <span class="el-icon-arrow-right"></span></el-button>
                  </router-link>
                </div>
              </div>
            </el-card>
          </el-col>
          <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
            <el-card :body-style="{ padding: '0px' ,textAlign: 'center'}">
              <img src="../assets/img/cs-home-3.jpg" class="image">
              <div class="img-tit">
                <span class="tit">高等教育</span>
                <div class="bottom clearfix">
                  <router-link to="Protrain">
                    <el-button type="text" class="button">进一步了解 <span class="el-icon-arrow-right"></span></el-button>
                  </router-link>
                </div>
              </div>
            </el-card>
          </el-col>
        </el-row>
      </div>
    </div>
  
    <!-- 即刻登入 -->
    <div class="cs-home-part3">
      <div class="container">
        <div class="con">
          <div class="tit">即刻登入，享受校园优惠</div>
          <div class="button">
            <a href="http://www.mac4me.com/" target="_blank">开始选购
              <span class="el-icon-arrow-right"></span>
            </a>
          </div>
          <div style="clear:both"></div>
          <img src="../assets/img/cs-home-4.png" alt="">
        </div>
      </div>
    </div>

    <div class="cs-home-part4">
      <img src="../assets/img/aipc.jpg" alt="" class="cs-home-part-4-img">
    </div>

    <div class="cs-home-part5">
      <div class="container">
        <div class="tit">辅助功能支持</div>
        <el-row class="as-promo">
          <el-col
            :xs="12"
            :sm="6"
            @click.native="openUrl('https://support.apple.com/zh-cn/102650')"
          >
            <img src="../assets/img/20250729/nav-icon-command_2x.svg" alt="">
            <span>
              <span>Mac 快捷键</span>
              <span>></span>
            </span>
          </el-col>
          <el-col 
            :xs="12"
            :sm="6"
            @click.native="openUrl('https://support.apple.com/zh-cn/guide/iphone/iphe867dc99c/ios')"
          >
            <img src="../assets/img/20250729/nav-icon-magnifier_2x.svg" alt="">
            <span>
              <span>iPhone 上的“放大器”</span>
              <span>></span>
            </span>
          </el-col>
          <el-col
            :xs="12"
            :sm="6"
            @click.native="openUrl('https://support.apple.com/zh-cn/111774')"
          >
            <img src="../assets/img/20250729/nav-icon-led-flash-alerts_2x.svg" alt="">
            <span>
              <span>LED 闪烁提醒</span>
              <span>></span>
            </span>
          </el-col>
          <el-col
            :xs="12"
            :sm="6"
            @click.native="openUrl('https://support.apple.com/zh-cn/111773')"
          >
            <img src="../assets/img/20250729/nav-icon-text-size_2x.svg" alt="">
            <span>
              <span>显示与文字大小</span>
              <span>></span>
            </span>
          </el-col>
        </el-row>

        <el-row class="as-content-block">
          <el-col
            :xs="24"
            :sm="12"
          >
            <img src="../assets/img/20250729/content-block-sm-personal-voice_2x.png" alt="">
            <h3>创建个人声音</h3>
            <p>你可以按照自己的声线创造一个拟真的合成语音，然后用它在进行 FaceTime 通话、打电话、使用辅助交流 App 以及面对面交谈时将键入的内容转换为语音*。</p>
            <span @click="openUrl('https://support.apple.com/zh-cn/104993')">
              <span>了解“个人声音”</span>
              <span>></span>
            </span>
          </el-col>
          <el-col
            :xs="24"
            :sm="12"
          >
            <img src="../assets/img/20250729/content-block-sm-live-speech_2x.png" alt="">
            <h3>通过实时语音交流</h3>
            <p>通过“实时语音”功能，你可以在使用 FaceTime 通话以及其他受支持的 App 时键入自己想说的内容，然后让系统大声读出来，或者在面对面交谈时键入自己想说的话，并通过设备扬声器转为清晰的语音。</p>
            <span @click="openUrl('https://support.apple.com/zh-cn/105018')">
              <span>了解实时语音</span>
              <span>></span>
            </span>
          </el-col>
        </el-row>

        <div class="accessibility-box">
          <img src="../assets/img/20250729/Accessibility.png" alt="">
        </div>

        <h2 class="as-section-title">资源</h2>

        <el-row class="as-content-block">
          <el-col
            :xs="24"
            :sm="12"
          >
            <img src="../assets/img/20250729/content-block-sm-user-guide_2x.png" alt="">
            <h3>盲文版《使用手册》</h3>
            <p>
              为你的设备下载通用英语盲文版《使用手册》文件 (.BRF)：<span @click="openUrl(BrailleZipUrl['Mac'])">Mac</span>、<span @click="openUrl(BrailleZipUrl['iPhone'])">iPhone</span>、<span @click="openUrl(BrailleZipUrl['AppleWatch'])">Apple Watch</span>、<span @click="openUrl(BrailleZipUrl['AppleTV'])">Apple TV</span> 或 <span @click="openUrl(BrailleZipUrl['HomePod'])">HomePod</span>。
            </p>
          </el-col>
          <el-col
            :xs="24"
            :sm="12"
          >
            <img src="../assets/img/20250729/content-block-sm-user-guide_2x.png" alt="">
            <h3>旁白</h3>
            <p>借助“旁白”功能，你可以听到屏幕上显示的内容，并使用简单的手势操控设备。了解如何在<span @click="openUrl(VoiceOverUrl['iPhone'])">iPhone</span>、<span @click="openUrl(VoiceOverUrl['iPad'])">iPad</span> 或 <span @click="openUrl(VoiceOverUrl['Mac'])">Mac</span>上使用“旁白”。
            </p>
          </el-col>
        </el-row>

        <h2 class="gb-header">如何联系 Apple 获取辅助功能方面的协助</h2>
        <p class="gb-subheader">通过电话或聊天，就 Apple 的语音、视觉、听觉、活动能力和认知障碍相关辅助功能获取协助。你甚至可以请求我们立即致电联系你，也可以安排一个时间让我们给你致电。只需回答几个问题，我们就会为你选择合适的方案。</p>
        <div class="gb-image">
          <img src="../assets/img/20250729/ios-17-accessibility-features.png" alt="">
        </div>

        <h3 class="call-header">致电寻求辅助功能方面的支持</h3>
        <p class="gb-paragraph">
          edu@jschuangsen.cn
          <br>
          服务热线：13681163410
        </p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'home',
  data() {
    return {
      BrailleZipUrl: {
        'Mac': 'https://support.apple.com/content/dam/edam/applecare/images/en_US/otherassets/accessibility/voiceover_user_guide_macos_15.zip',
        'iPhone': 'https://support.apple.com/content/dam/edam/applecare/images/en_US/otherassets/accessibility/iphone_user_guide_ios_18.zip',
        'AppleWatch': 'https://support.apple.com/content/dam/edam/applecare/images/en_US/otherassets/accessibility/watch_OS11_UG.zip',
        'AppleTV': 'https://support.apple.com/content/dam/edam/applecare/images/en_US/otherassets/accessibility/appletv_user_guide_tvos_18.zip',
        'HomePod': 'https://support.apple.com/content/dam/edam/applecare/images/en_US/otherassets/accessibility/homepod_user_guide_tvos_17.zip',
      },
      VoiceOverUrl: {
        'iPhone': 'https://support.apple.com/zh-cn/guide/iphone/turn-on-and-practice-voiceover-iph3e2e415f/ios',
        'iPad': 'https://support.apple.com/zh-cn/guide/ipad/turn-on-and-practice-voiceover-ipad9a246898/ipados',
        'Mac': 'https://support.apple.com/zh-cn/guide/voiceover',
      }
    }
  },
  mounted() {
    console.log('202507')
  },
  components: {
  },
  methods: {
    openUrl(url) {
      window.open(url, url.indexOf('.zip') > -1 ? '_self' : '_blank')
    },
  }
}
</script>

<style lang="scss">
  .cs-home{
    .cs-home-part1{
      text-align: center;
      height: 1200px;
      background: url(../assets/img/cs-home-1.png) no-repeat #fff;
      background-position: center 100px;
      background-size:auto auto;
      .cs-home-con{
        max-width: 930px;
        margin: 0 auto;
      }
      .tit{
        padding: 110px 0 50px 0;
      }
      .subtitle{
        padding-bottom: 10px;
      }
      .con{
        letter-spacing: 0.2px;
        text-indent: 0;
        text-align: justify;
        &:last-child{
          margin-top: 40px;
        }
      }
    }
    // 基础教育--高等教育
    .cs-home-part2{
      padding: 85px 0;
      overflow: hidden;
      .image {
        width: 100%;
        height: 350px;
        display: block;
      }
      .el-card,.el-card__body{
        border-radius: 22px;
      }
      .img-tit{
        width: 100%;
        height: 190px;
        padding-top: 40px;
        background-color: #fff;
        text-align: center;
        span.tit{
          font-size: 40px;
          font-weight: 600;
          color: #000000;
        }
        .button span{
          font-size: 22px;
          font-weight: 400;
          color: #0071E3;
        }
      }
    }
    // 即刻登入
    .cs-home-part3{
      background: #fff;
      padding: 20px 0 120px 0;
      img{
        max-width: 100%;
      }
      .container {
        display: flex;
        justify-content: center;
      }
      @media screen and (max-width: 750px) {
          img{
            max-width: 75%;
          }
      }
      .con{
        display: table-cell;
        vertical-align: middle;
        text-align: center;
        .tit{
          font-size: 40px;
          font-weight: 600;
          color: #000000;
          padding: 78px 0 40px 0;
        }
        .button{
          width: 240px;
          height: 76px;
          background: #0071E3;
          border-radius: 38px;
          display: inline-block;
          margin-bottom: 55px;
          a{
            display: block;
            width: 100%;
            height: 100%;
            text-align: center;
            line-height: 76px;
            font-size: 28px;
            font-weight: 400;
            color: #FFFFFF;
          }
        }
      }
    }
    .cs-home-part4{
      display: flex;
      justify-content: center;
      background-color: white;
      img{
        max-width: 80%;
      }
    }


    .cs-home-part5{
      padding-bottom: 50px;
      background-color: #fff;
      .tit{
        text-align: center;
      }
      .as-promo{
        margin-top: 54px;
        .el-col{
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          cursor: pointer;
          img{
            width: 60px;
            height: 60px;
          }
          & > span{
            margin-top: 15px;
            font-size: 18px;
            color: #0071E3;
            span:first-child{
              margin-right: 5px;
            }
          }
          &:hover{
            & > span{
              span:first-child{
                text-decoration: underline;
              }
            }
          }
        }
      }
      .as-content-block{
        margin-top: 68px;
        padding: 0 60px;
        .el-col{
          padding: 0 25px;
          display: flex;
          flex-direction: column;
          color: #1d1d1f;
          img{
            width: 75px;
            height: 75px;
          }
          h3{
            margin-top: 20px;
            font-size: 24px;
          }
          p{
            margin-top: 14px;
            font-size: 18px;
            span{
              color: #0071E3;
              cursor: pointer;
              &:hover{
                text-decoration: underline;
              }
            }
          }
          & > span{
            margin-top: 14px;
            font-size: 18px;
            color: #0071E3;
            cursor: pointer;
            span:first-child{
              margin-right: 5px;
            }
            &:hover{
              span:first-child{
                text-decoration: underline;
              }
            }
          }
        }
      }

      .accessibility-box{
        margin-top: 65px;
        text-align: center;
        img{
          width: 80%;
        }
      }

      .as-section-title{
        margin-top: 68px;
        font-size: 40px;
        font-weight: 600;
        text-align: center;
      }

      .gb-header{
        margin-top: 68px;
        font-size: 42px;
        font-weight: 600;
        text-align: center;
      }

      .gb-subheader{
        margin: 30px auto 0;
        font-size: 18px;
        max-width: 1000px;
      }

      .gb-image{
        margin-top: 25px;
        text-align: center;
        img{
          width: 100%;
          max-width: 980px;
        }
      }

      .call-header{
        margin: 40px auto 0;
        font-size: 42px;
        font-weight: 600;
        max-width: 1000px;
        text-align: center;
      }

      .gb-paragraph{
        margin: 15px auto 0;
        font-size: 18px;
        max-width: 1000px;
        text-align: center;
      }
    }
  }

// 适配
@media screen and (max-width: 768px) {
  .cs-home .cs-home-part2 .el-card{
    &:first-child{
      margin-bottom: 80px;
    }
  }
  .cs-home-part1{
    height: auto!important;
    background-size:95% auto!important;
    background-position: center bottom !important;
    padding-bottom: 40vw !important;
    .cs-home-con{
      width: auto!important;
    }
  }
}
</style>
